import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { BreakDownData, RealChartData } from './types';
import intl from 'react-intl-universal';

type ToolTipFormatterParam = {
  seriesType: string;
  value: number;
  marker?: string;
  seriesName?: string;
  axisValueLabel?: string;
};

export const formatChartsTooltip = (params: ToolTipFormatterParam[]) => {
  // `params` is an array of objects, each representing a series
  const paramsBySeriesType: Record<string, Array<ToolTipFormatterParam>> = {};

  params.forEach((param) => {
    let items = get(paramsBySeriesType, param.seriesType) || [];
    items.push(param);
    paramsBySeriesType[param.seriesType] = items;
  });

  let tooltipContent = `<div class="font-proxima-nova text-sm"><p class="mb-2">${get(
    params,
    '0.axisValueLabel'
  )}</p>`;

  const tooltipContents = [];
  for (let t of Object.keys(paramsBySeriesType)) {
    const paramsInType = paramsBySeriesType[t];
    let total = 0;
    let tooltipContent = '';
    for (let param of paramsInType) {
      tooltipContent += `<div class="flex justify-between items-center gap-2"><span> ${
        param.marker
      } ${param.seriesName}</span> <strong>${(
        param.value || 0
      ).toLocaleString()}</strong></div>`;
      total += param.value || 0;
    }
    if (paramsInType.length > 1) {
      // Add the total sum to the tooltip
      tooltipContent += `<div class="flex justify-between items-center gap-2 mt-2">${intl.get(
        'INSIGHT.TOOLTIP.TOTAL'
      )}<strong>${total.toLocaleString()}</strong></div>`;
    }
    tooltipContents.push(tooltipContent);
  }

  tooltipContent +=
    tooltipContents.join(
      '<div class="w-full border-t border-dashed my-2"></div>'
    ) + `</div>`;
  return tooltipContent;
};

export const getRequestsBreakdownData = (
  chartData: RealChartData,
  categoryName: string
): BreakDownData => {
  let output: BreakDownData = {
    statusNames: [],
    data: [],
  };
  let data = chartData || [];
  if (!data || !data.length) return output;
  let availableStatusNames: Set<string> = new Set();
  let dataMap: Record<string, Record<string, number>> = {};
  for (let datum of data) {
    let unitTitle = get(datum, categoryName);
    let innerMap = { ...get(dataMap, unitTitle, {}) };
    if (isEmpty(innerMap)) {
      innerMap = { ...datum };
    }
    let status = get(datum, 'request_status');
    availableStatusNames.add(status as string);
    innerMap[status] = get(datum, 'request_count');
    dataMap[unitTitle] = innerMap;
  }
  output.statusNames = [...availableStatusNames];
  for (let k of Object.keys(dataMap)) {
    output.data.push(get(dataMap, k));
  }
  return output;
};

export const getProjectsBreakdownData = (
  chartData: RealChartData,
  categoryName: string
): BreakDownData => {
  let output: BreakDownData = {
    statusNames: [],
    data: [],
  };
  let data = chartData || [];
  if (!data || !data.length) return output;
  let availableStatusNames: Set<string> = new Set();
  let dataMap: Record<string, Record<string, number>> = {};
  for (let datum of data) {
    let unitTitle = get(datum, categoryName);
    let innerMap = { ...get(dataMap, unitTitle, {}) };
    if (isEmpty(innerMap)) {
      innerMap = { ...datum };
    }
    let status = get(datum, 'project_status_group');
    availableStatusNames.add(status as string);
    innerMap[status] = get(datum, 'project_count');
    dataMap[unitTitle] = innerMap;
  }
  output.statusNames = [...availableStatusNames];
  for (let k of Object.keys(dataMap)) {
    output.data.push(get(dataMap, k));
  }
  return output;
};
